"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_arrow_min_top_style_1 = __importDefault(require("./uicon.arrow.min.top.style"));
class UiconArrowMinTop extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: jsx_runtime_1.jsx("path", { d: "M15.5045 12H15.5105C15.6475 11.9998 15.7822 12.0357 15.9009 12.1042C16.0196 12.1727 16.1181 12.2713 16.1865 12.39L19.8945 18.83C19.9666 18.9473 20.0048 19.0823 20.0048 19.22C20.0048 19.3577 19.9666 19.4927 19.8945 19.61C19.8272 19.7281 19.7299 19.8264 19.6125 19.8949C19.495 19.9634 19.3615 19.9997 19.2255 20H11.7855C11.6481 20.001 11.5129 19.9656 11.3936 19.8976C11.2743 19.8295 11.175 19.7311 11.1059 19.6124C11.0368 19.4936 11.0003 19.3587 11 19.2214C10.9998 19.084 11.0358 18.949 11.1045 18.83L14.8285 12.39C14.897 12.2713 14.9956 12.1728 15.1142 12.1044C15.2329 12.0359 15.3675 11.9999 15.5045 12Z", className: classes.fill }, void 0) }), void 0));
        };
    }
}
UiconArrowMinTop.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconArrowMinTop.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_arrow_min_top_style_1.default)(UiconArrowMinTop);
//# sourceMappingURL=uicon.arrow.min.top.js.map